<h1 mat-dialog-title>{{data.title | async}}</h1>
<p mat-dialog-content>
  {{ "message.removeOccurrence.confirmation" | translate | async }}
</p>
<div mat-dialog-actions>
  <vue-basic-button (clicked)="closeDialog()">
    {{ "button.cancel" | translate | async }}
  </vue-basic-button>
  <vue-flat-button (clicked)="removeOccurrence()">
    {{ "button.remove" | translate | async }}
  </vue-flat-button>
</div>
